
import { Component, Vue, Watch } from 'vue-property-decorator'
import AppHeader from '@/components/AppHeader.vue'
import AppLoadingCircular from '@/components/AppLoadingCircular.vue'
import PartnersHeader from '@/components/PartnersHeader.vue'
import PartnersSearch from '@/components/PartnersSearch.vue'
import PartnersTable from '@/components/PartnersTable.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { cloneDeep } from 'lodash'

@Component({
    name: 'Partners',
    components: {
        AppHeader,
        AppLoadingCircular,
        FontAwesomeIcon,
        PartnersHeader,
        PartnersSearch,
        PartnersTable,
    },
})

export default class Partners extends Vue {
    get rows() {
        return this.$store.state.partners.partners
    }

    get isLoading(): boolean {
        return this.$store.state.partners.isLoading
    }

    get filters() {
        return this.$store.state.partners.filters
    }

    @Watch('filters')
    public onChangeFilters(newFilters: any, _: any) {
        this.$router.replace({ query: {
            nameOrCnpj: newFilters.nameOrCnpj,
            category: newFilters.category,
            status: newFilters.status,
            apikeyStatus: newFilters.apikeyStatus,
        }}).catch(() => {
            // Não deveria acontecer
        })
    }

    public parseFilters() {
        const query = cloneDeep(this.filters)
        const queryString = this.$route.query

        const nameOrCnpj = queryString.nameOrCnpj
        const category = queryString.category
        const status = queryString.status
        const apikeyStatus = queryString.apikeyStatus

        if (typeof nameOrCnpj === 'string') {
            query.nameOrCnpj = nameOrCnpj
        }

        if (typeof category === 'string') {
            query.category = category
        }

        if (typeof status === 'string') {
            query.status = status
        }

        if (typeof apikeyStatus === 'string') {
            query.apikeyStatus = apikeyStatus
        }

        return query
    }

    public async mounted() {
        const queryFilter = this.parseFilters()

        this.$store.dispatch('partners/filterPartners', queryFilter)
    }
}
